import * as React from 'react'
import { SVGProps } from 'react'

const SvgUploadIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <g clipPath='url(#uploadIcon_svg__a)' fill='#fff'>
      <path d='m8.081 13.51 2.926 2.927L11 1a1 1 0 0 1 2 0l.007 15.42 2.912-2.913a1 1 0 0 1 1.414 1.414l-3.21 3.215a3 3 0 0 1-4.243.002l-.002-.002-3.21-3.212A1 1 0 0 1 8.08 13.51Z' />
      <path
        opacity={0.4}
        d='M23 16a1 1 0 0 0-1 1v4a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-4a1 1 0 1 0-2 0v4a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3v-4a1 1 0 0 0-1-1Z'
      />
    </g>
    <defs>
      <clipPath id='uploadIcon_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
)

export default SvgUploadIcon
